var moduleMap = {
	"./ProcessManager": () => {
		return __webpack_require__.e(4816).then(() => (() => ((__webpack_require__(84816)))));
	},
	"./ppPrivateFetcher": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(5139), __webpack_require__.e(8694), __webpack_require__.e(8960), __webpack_require__.e(4345), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(1365)]).then(() => (() => ((__webpack_require__(1611)))));
	},
	"./appStateManager": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(5139), __webpack_require__.e(8694), __webpack_require__.e(8960), __webpack_require__.e(4345), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(2511)]).then(() => (() => ((__webpack_require__(77849)))));
	},
	"./ppUserAccountService": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(5139), __webpack_require__.e(8694), __webpack_require__.e(8960), __webpack_require__.e(4345), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(9853)]).then(() => (() => ((__webpack_require__(281)))));
	},
	"./ppAppEndpointsConfig": () => {
		return Promise.all([__webpack_require__.e(1858), __webpack_require__.e(9306)]).then(() => (() => ((__webpack_require__(59306)))));
	},
	"./fetchers/ppWebhook": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(5139), __webpack_require__.e(8694), __webpack_require__.e(8960), __webpack_require__.e(4345), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(7815)]).then(() => (() => ((__webpack_require__(69220)))));
	},
	"./fetchers/ppPrivateFetcher": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(5139), __webpack_require__.e(8694), __webpack_require__.e(8960), __webpack_require__.e(4345), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(1365)]).then(() => (() => ((__webpack_require__(1611)))));
	},
	"./fetchers/ppCustomNotification": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(5139), __webpack_require__.e(8694), __webpack_require__.e(8960), __webpack_require__.e(7108), __webpack_require__.e(4345), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(9267), __webpack_require__.e(872)]).then(() => (() => ((__webpack_require__(30241)))));
	},
	"./fetchers/ppTrackingWidgetFetcher": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(5139), __webpack_require__.e(8694), __webpack_require__.e(8960), __webpack_require__.e(4345), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(3352)]).then(() => (() => ((__webpack_require__(75684)))));
	},
	"./constants/productExperience.constant": () => {
		return __webpack_require__.e(8009).then(() => (() => ((__webpack_require__(88009)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});